// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"Autocomplete_itemContainer__1_iin","menu":"Autocomplete_menu__jb4Bg","curtain":"Autocomplete_curtain__1U99D"};